module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAaCAYAAADSbo4CAAAACXBIWXMAAAsSAAALEgHS3X78AAABBklEQVRIie2XvaqDMBSAjyaLcAdB6iNcR4W8QB+pY8eufZuOfQkhHXXKoosIgqCoaMqxFXq9f9uxQ74lOWfJR5ITTiwppQRitNbXKIqOr6taWZZpSo2qqqBtW2CMnV9lLK01qcg4jpAkCQzDcAvDMFryNqUEwhgD13W/5clFfsOIrCEXaZoG+r7HEv6I43i/5EmrRikFZVl+ydm2XUzT9MmpJHAXUMJxHAiCYK4ejJVSOwA4kB1N13XzuEggnueB7/vzfJN35KfYlO8aI7LGiKx5GxFe1zXJQtiV/SmSpimJyH9wIcRbiJjLCs9GGrt6hOd5vpnI8rUAAMmLorhtZvLgJIS43AERG2fPt4drgQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat/seatSaleR.png
// module id = /1ze
// module chunks = 1